module.exports = __webpack_public_path__ + "static/media/404.ffbe7e80.png";